import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

export const BookCard = ({ book }) => {
  return (
    <Link to={`/book/${book.book_id}`} data-testid={`book-card-${book.book_id}`}>
      <Card className="group overflow-hidden border-0 shadow-none hover:shadow-soft transition-all duration-300 rounded-xl">
        <div className="relative aspect-[2/3] overflow-hidden bg-pink-50/50 rounded-xl">
          <img
            src={book.cover_image}
            alt={book.title}
            className="w-full h-full object-cover img-matte group-hover:scale-105 transition-transform duration-500"
          />
          {book.is_new_release && (
            <Badge 
              className="absolute top-3 left-3 font-accent text-[10px] uppercase tracking-wider bg-primary text-primary-foreground rounded-full px-3"
            >
              New
            </Badge>
          )}
          {book.is_featured && !book.is_new_release && (
            <Badge 
              className="absolute top-3 left-3 font-accent text-[10px] uppercase tracking-wider bg-foreground text-background rounded-full px-3"
            >
              Featured
            </Badge>
          )}
        </div>
        <CardContent className="px-1 pt-4">
          <p className="font-accent text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-1">
            {book.category}
          </p>
          <h3 className="font-heading text-lg font-semibold leading-tight mb-1 group-hover:text-primary transition-colors">
            {book.title}
          </h3>
          <p className="text-sm text-muted-foreground mb-2">{book.author}</p>
          <p className="font-semibold text-primary">${book.price.toFixed(2)}</p>
        </CardContent>
      </Card>
    </Link>
  );
};
